
import { EditIcon, IconButton, MuiTooltip } from '@common';

const CommonEditButton = ({ handleClick, removePadding = false, permission = true, title = "Edit", sx = {}, }) => {
    if (!permission) return null;
    return (
        <MuiTooltip title={title}>
            <IconButton
                onClick={handleClick}
                sx={{
                    ...(removePadding && {
                        padding: 0
                    })
                }}
            >
                <EditIcon
                    sx={{
                        color: "#00527d",
                        cursor: "pointer",
                        ...sx,
                    }}
                />
            </IconButton>
        </MuiTooltip>
    )
}
export default CommonEditButton